<script>
    import axios from 'axios'
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import AdaptersDropdown from "../../../component/adapters/Dropdown.vue";
    import Checkbox from "primevue/checkbox";
    import debounce from "lodash/debounce";

    export default {
        data() {
            return {
                loading: false,
                projectName: "",
                groupReports: [],
                groupReport: null,
                filter: "",
                error: null,
                model: {},
            }
        },
        props: ["name", "base", "uid"],
        methods: {
            uploadData(){
                this.$upload.start(this.key);
            },
            save(){

                let self = this;
                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: {
                        rid: this.groupReport.rid,
                        context: this.model.context,
                        organic: this.model.organic
                    }
                })
                    .then(function (response) {
                        self.loading = false;
                        window.location.reload();
                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });

            },
            loadGroupReports(){
                let self = this;
                self.loading = true;
                axios({
                    method: 'get',
                    url: this.getGroupApiUrl,
                    withCredentials: true
                })
                    .then(function (response) {
                        self.loading = false;
                        self.groupReports =  response.data.data;
                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });

            },
            onOpen() {
                this.loadGroupReports();
                this.groupReport = null;
                this.error = null;
                this.model = {
                    organic: true,
                    context: false,
                };
            },
            getDropdownCaption(slotProps) {
                let data = slotProps.value ?? slotProps.option;
                if (!data) {
                    return slotProps.placeholder;
                }

                let caption = data.name;
                if (data.owner) {
                    caption += ' (' + data.owner + ')';
                }

                return caption;
            },
            onFilterChange: debounce(function (e) {
                this.filter = e.value;
                this.loadGroupReports()
            }, 1000),
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/clustering/' + this.uid + '/import/group_report' ;
            },
            getGroupApiUrl(){
                let filter = 'state=10^base=' + this.base;
                if (this.groupReport) {
                    filter += '^ORrid=' + this.groupReport.rid;
                }
                if (this.filter) {
                    filter += '^nameLIKE' + this.filter;
                }
                return this.$config.API_URL + '/report/group/list?sort=' + encodeURIComponent('access_date|desc') + '&filter=' + encodeURIComponent(filter);
            },
            getGroupReportsWithFullTitles() {
                let self = this;

                return this.groupReports.map(item => {
                    let baseCaption = self.$tm('lang.main.bases').filter(
                        itemBase => itemBase.name === item.base
                    )[0].caption;
                    let title = (item.name ?? self.$t('lang.cluster.no_project_name')) + ' ' + baseCaption;

                    if (item.owner) {
                        title += ' (' + item.owner + ')';
                    }

                    item.title = title;

                    return item;
                });
            },
        },
        components: {
            AdaptersDropdown,
            AdaptersDialog,
            Checkbox,
        },
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="name"
        :callback-on-show="onOpen"
        :header="$t('lang.cluster.import_from_gr')"
        :loading="loading"
        :error-message="error"
        :callback-agree="save"
        :button-agree-label="$t('lang.main.btn.add')"
    >
        <template #content>
            <div class="field">
                <label>{{$t('lang.cluster.keywords')}}</label>
                <AdaptersDropdown
                    v-model="groupReport"
                    :options="getGroupReportsWithFullTitles"
                    class="w-full"
                    :placeholder="$t('lang.cluster.choose_report')"
                    :filter="true"
                    @filter="onFilterChange"
                    :pt="{
                        filterinput: {class: 'w-full'}
                    }"
                >
                    <template #value="slotProps">
                        <span>{{ getDropdownCaption(slotProps) }}</span>
                    </template>
                    <template #option="slotProps">
                        <span>{{ getDropdownCaption(slotProps) }}</span>
                    </template>
                </AdaptersDropdown>
            </div>
            <div class="formgroup-inline">
                <div class="field-checkbox">
                    <Checkbox v-model="model.organic" inputId="organic" binary />
                    <label for="organic">{{ $t('lang.cluster.import_organic') }}</label>
                </div>
                <div class="field-checkbox">
                    <Checkbox v-model="model.context" inputId="context" binary />
                    <label for="context">{{ $t('lang.cluster.import_context') }}</label>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>

